import { useEffect } from 'react';
import { isRenderingOnServer } from '~/helpers/projectConstant.ts';

export function useIframeHeight() {
  useEffect(() => {
    if (isRenderingOnServer()) return;
    if (!window.parent || window.parent === window) return;

    let raf: number | null = null;

    const sendHeight = () => {
      if (raf) return;

      raf = requestAnimationFrame(() => {
        raf = null;

        const root = document.getElementById('root') ?? document.body;
        const height = root.getBoundingClientRect().height;

        window.parent.postMessage(
          {
            type: 'ADVIESKEUZE_IFRAME_HEIGHT',
            height: Math.ceil(height),
          },
          '*'
        );
      });
    };

    sendHeight();

    const observer = new ResizeObserver(sendHeight);
    
    const root = document.getElementById('root');
    if (root) observer.observe(root);
    
    window.addEventListener('resize', sendHeight);

    if (document.fonts?.ready) {
      document.fonts.ready.then(sendHeight);
    }

    return () => {
      observer.disconnect();

      window.removeEventListener('resize', sendHeight);

      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
}
